import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // This ensures the service is available application-wide
})
export class LocalStorageService {
  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  // Get data from localStorage
  getItem(key: string) {
    return localStorage.getItem(key);
  }

  // Save data to localStorage
  setJsonItem(key: string, value: any): void {
    try {
      const jsonData = JSON.stringify(value);
      localStorage.setItem(key, jsonData);
    } catch (e) {
      console.error(`Error saving to localStorage`, e);
    }
  }

  // Get data from localStorage
  getJsonItem<T>(key: string): T | null {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (e) {
      console.error(`Error reading from localStorage`, e);
      return null;
    }
  }

  // Remove data from localStorage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all localStorage (use with caution)
  clear(): void {
    localStorage.clear();
  }
}
